import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export function PlanHistoryErrorAlert () {
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'planHistory.errorAlert'
  })

  return <Alert variation="warn">{t('content')}</Alert>
}
export default PlanHistoryErrorAlert
